'use strict';

export default function routes($routeProvider) {
  'ngInject';
  $routeProvider
    .when('/shops', {
      template: require('./shops.pug'),
      controller: 'ShopsController',
      controllerAs: 'shops',
    });
};




// WEBPACK FOOTER //
// ./client/app/manager/shops/shops.routes.ts